export default function ProgramIncludes() {
  const items = [
    { icon: 'ri-search-eye-line', title: 'Диагностика', desc: 'Анализ текущих показателей: конверсия, воронка, средний чек, маржинальность. Аудит звонков и переписок.' },
    { icon: 'ri-file-settings-line', title: 'Подготовка', desc: 'Изучение продукта, рынка, конкурентов. Интервью с руководителем и ключевыми сотрудниками.' },
    { icon: 'ri-presentation-line', title: 'Практический тренинг', desc: '80% практики: ролевые игры, разбор реальных кейсов, отработка навыков на материале компании.' },
    { icon: 'ri-task-line', title: 'Домашние задания', desc: 'Закрепление навыков между модулями. Конкретные задачи с дедлайнами и проверкой.' },
    { icon: 'ri-phone-find-line', title: 'Разбор звонков', desc: 'Прослушивание и анализ реальных звонков участников. Детальная обратная связь по каждому.' },
    { icon: 'ri-chat-check-line', title: 'Разбор переписок', desc: 'Анализ деловой переписки и коммерческих предложений. Корректировка текстов.' },
    { icon: 'ri-user-settings-line', title: 'Работа с руководителем', desc: 'Обучение РОПа инструментам контроля качества, наставничества и развития команды.' },
    { icon: 'ri-refresh-line', title: 'Посттренинговое сопровождение', desc: 'Поддержка внедрения от 1 до 6 месяцев. Регулярные встречи, аудит, корректировка.' },
  ];

  return (
    <section id="program" className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            Что входит в программу <strong>корпоративного тренинга по продажам</strong>
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            <strong>Обучение продажам</strong> — это не разовое мероприятие, а комплексная программа. Каждый элемент работает на закрепление навыков и внедрение изменений в ежедневную работу.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {items.map((item, i) => (
            <div key={i} className="bg-white rounded-xl p-6 hover:shadow-md hover:-translate-y-0.5 transition-all duration-300 group cursor-default">
              <div className="w-11 h-11 bg-teal-100 rounded-lg flex items-center justify-center mb-4 group-hover:bg-teal-600 transition-colors duration-300 flex-shrink-0">
                <i className={`${item.icon} text-lg text-teal-600 group-hover:text-white transition-colors duration-300`}></i>
              </div>
              <h3 className="text-base font-bold text-gray-900 mb-2">{item.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}